/*
 *
 * @providesModule UnifiedLoginCohortUtility
 *
 */

import ClientPropertyConstants, {FTUEv3SignUpPath} from 'ClientPropertyConstants';

export const getCohort = () => {
  return ClientPropertyConstants.getFTUEv3SignUpPath() === FTUEv3SignUpPath.AutoGuest
    ? 'Guest_path'
    : 'Unified_login_path';
};
